import React from 'react';

// Step 2: Financial Information — Section B
export function renderFinancial(formData, handleInputChange, errors) {
  const incomeOptions = [
    { value: 'age_pension',          label: 'Age Pension' },
    { value: 'disability_pension',   label: 'Disability Support Pension' },
    { value: 'superannuation',       label: 'Superannuation' },
    { value: 'part_time_employment', label: 'Part-time employment' },
    { value: 'investments',          label: 'Investment income' },
    { value: 'family_friends',       label: 'Family & friends' },
    { value: 'loans',                label: 'Loans' },
    { value: 'other',                label: 'Other' },
  ];

  return (
    <div className="form-step" data-testid="step-2">
      <h2>Section B — Financial Circumstances</h2>
      <p className="step-description">This information helps us ensure housing arrangements are affordable and sustainable. All financial information is confidential.</p>

      <div className="form-group">
        <label className="input-label">B1. Primary Income Source * (tick all applicable)</label>
        <p className="field-hint">And excluding any current Commonwealth Rent Assistance (CRA)</p>
        <div className="checkbox-grid two-col">
          {incomeOptions.map(opt => (
            <label key={opt.value} className="checkbox-label">
              <input type="checkbox" name="income_sources[]" value={opt.value} checked={formData.income_sources?.includes(opt.value)} onChange={handleInputChange} data-testid={`income-${opt.value}`} />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
        {errors.income_sources && <span className="error-message">{errors.income_sources}</span>}
      </div>

      <div className="form-group">
        <label className="input-label">B2. What's the maximum weekly rent you'd be comfortable with? (to share a property)</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontWeight: '700', fontSize: '16px' }}>$</span>
          <input type="number" name="maximum_weekly_rent" value={formData.maximum_weekly_rent} onChange={handleInputChange} className="input-field" min="0" placeholder="0" data-testid="maximum-rent" />
        </div>
      </div>
    </div>
  );
}

// Step 3: Lifestyle — Section C
export function renderLifestyle(formData, handleInputChange, errors) {
  const hobbiesOptions = [
    'Gardening', 'Television/Movies', 'Card games', 'Painting', 'Crafts', 'Gaming',
    'Music playing', 'Bowls', 'Table tennis', 'Pool/Snooker/Billiards',
    'Restaurants/Bistros/Cafes', 'Bands - listening', 'Walking/Running', 'Swimming',
    'Cooking/Baking', 'Chess/Draughts/Go', 'Puzzles/Crosswords', 'Sewing/Embroidery',
    'Computers/Internet/Web', 'Music listening', 'Cars/Car maintenance',
    'Badminton', 'Tennis or similar', 'Dancing', 'Bars - drinking', 'Gym/Yoga',
    'Bushwalking', 'Karaoke', 'Kayaking', 'Sailing', 'Surfing'
  ];

  return (
    <div className="form-step" data-testid="step-3">
      <h2>Section C — Lifestyle <span style={{ fontSize: '0.65em', color: '#dc2626', fontWeight: 600, marginLeft: '8px' }}>(COMBINED/SHARED IF COUPLE)</span></h2>
      <p className="step-description">Tell us about your daily life to find compatible housemates.</p>

      <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '12px 16px', margin: '12px 0 20px', fontSize: '14px', color: '#1e40af' }}>
        <strong>All HSS properties are smoke-free.</strong>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="input-label">C2. Do you have pets?</label>
          <div className="radio-group">
            <label className="radio-label">
              <input type="radio" name="has_pets" value="true" checked={formData.has_pets === true} onChange={() => handleInputChange({ target: { name: 'has_pets', value: true }})} data-testid="has-pets-yes" />
              <span>Yes</span>
            </label>
            <label className="radio-label">
              <input type="radio" name="has_pets" value="false" checked={formData.has_pets === false} onChange={() => handleInputChange({ target: { name: 'has_pets', value: false }})} data-testid="has-pets-no" />
              <span>No</span>
            </label>
          </div>
        </div>
      </div>

      {formData.has_pets && (
        <div className="form-group">
          <label className="input-label">C3. Pet Details</label>
          <input type="text" name="pet_details" value={formData.pet_details} onChange={handleInputChange} className="input-field" placeholder="e.g., Small dog, indoor cat" data-testid="pet-details-input" />
        </div>
      )}

      <div className="form-group">
        <label className="input-label">C4. Daily Routine *</label>
        <p className="field-hint">Select all that apply</p>
        <div className="checkbox-grid two-col">
          <label className="checkbox-label"><input type="checkbox" name="daily_routine[]" value="early_riser" checked={Array.isArray(formData.daily_routine) ? formData.daily_routine.includes('early_riser') : formData.daily_routine === 'early_riser'} onChange={handleInputChange} /><span>Early riser (up before 7am)</span></label>
          <label className="checkbox-label"><input type="checkbox" name="daily_routine[]" value="morning_person" checked={Array.isArray(formData.daily_routine) ? formData.daily_routine.includes('morning_person') : formData.daily_routine === 'morning_person'} onChange={handleInputChange} /><span>Morning person (up 7-9am)</span></label>
          <label className="checkbox-label"><input type="checkbox" name="daily_routine[]" value="late_riser" checked={Array.isArray(formData.daily_routine) ? formData.daily_routine.includes('late_riser') : formData.daily_routine === 'late_riser'} onChange={handleInputChange} /><span>Late riser (up after 9am)</span></label>
          <label className="checkbox-label"><input type="checkbox" name="daily_routine[]" value="night_owl" checked={Array.isArray(formData.daily_routine) ? formData.daily_routine.includes('night_owl') : formData.daily_routine === 'night_owl'} onChange={handleInputChange} /><span>Night owl (active in evenings)</span></label>
          <label className="checkbox-label"><input type="checkbox" name="daily_routine[]" value="early_bed" checked={Array.isArray(formData.daily_routine) ? formData.daily_routine.includes('early_bed') : formData.daily_routine === 'early_bed'} onChange={handleInputChange} /><span>Early to bed</span></label>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">C5. Hobbies and Interests</label>
        <p className="field-hint">Select all that apply</p>
        <div className="checkbox-grid two-col">
          {hobbiesOptions.map(hobby => (
            <label key={hobby} className="checkbox-label">
              <input type="checkbox" name="hobbies[]" value={hobby} checked={formData.hobbies?.includes(hobby)} onChange={handleInputChange} data-testid={`hobby-${hobby.toLowerCase().replace(/[\s\/]/g, '-')}`} />
              <span>{hobby}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">C6. Other Hobbies or Interests</label>
        <input type="text" name="other_hobbies" value={formData.other_hobbies} onChange={handleInputChange} className="input-field" placeholder="Other hobbies or interests..." data-testid="other-hobbies-input" />
      </div>
    </div>
  );
}

// Step 4: Household & Community — Section D
export function renderHousehold(formData, handleInputChange, errors) {
  const responsibilityOptions = [
    'Happy to help with cleaning shared areas',
    'Happy to help with garden care',
    'Happy to help with property maintenance',
    'Happy to help with grocery shopping',
    'Happy to help with transport for our community (with shared costs)',
  ];

  return (
    <div className="form-step" data-testid="step-4">
      <h2>Section D — Household &amp; Community</h2>
      <p className="step-description">Tell us about your preferences for shared living.</p>

      <div className="form-group">
        <label className="input-label">D1. Household Responsibilities (Select all that apply)</label>
        <div className="checkbox-grid one-col">
          {responsibilityOptions.map(resp => (
            <label key={resp} className="checkbox-label">
              <input type="checkbox" name="household_responsibilities[]" value={resp} checked={formData.household_responsibilities?.includes(resp)} onChange={handleInputChange} />
              <span>{resp}</span>
            </label>
          ))}
          <label className="checkbox-label">
            <input type="checkbox" name="appreciate_help_with_tasks" checked={formData.appreciate_help_with_tasks} onChange={(e) => handleInputChange({ target: { name: 'appreciate_help_with_tasks', value: e.target.checked }})} />
            <span>Would appreciate help with some tasks</span>
          </label>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">D2. Transportation</label>
        <label className="checkbox-label">
          <input type="checkbox" name="happy_to_share_transport" checked={formData.happy_to_share_transport} onChange={(e) => handleInputChange({ target: { name: 'happy_to_share_transport', value: e.target.checked }})} />
          <span>Happy to share car driving &amp; expenses</span>
        </label>
      </div>

      <div className="form-group">
        <label className="input-label">D3. Cooking Preference *</label>
        <div className="radio-group vertical">
          <label className="radio-label"><input type="radio" name="cooking_preference" value="own_cooking" checked={formData.cooking_preference === 'own_cooking'} onChange={handleInputChange} /><span>Prefer to do all my/our own cooking</span></label>
          <label className="radio-label"><input type="radio" name="cooking_preference" value="occasional_communal" checked={formData.cooking_preference === 'occasional_communal'} onChange={handleInputChange} /><span>Happy to have &amp; help with occasional communal cooking &amp; meals</span></label>
          <label className="radio-label"><input type="radio" name="cooking_preference" value="regular_communal" checked={formData.cooking_preference === 'regular_communal'} onChange={handleInputChange} /><span>Happy to have &amp; help with regular communal cooking &amp; meals</span></label>
          <label className="radio-label"><input type="radio" name="cooking_preference" value="frequent_communal" checked={formData.cooking_preference === 'frequent_communal'} onChange={handleInputChange} /><span>Happy to have &amp; help with frequent communal cooking &amp; meals</span></label>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label" style={{ fontWeight: '700', fontSize: '15px', color: '#1a2332' }}>Visitors &amp; Guests</label>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="input-label">D4. How often would you expect to entertain family &amp; friends?</label>
          <div className="radio-group vertical">
            <label className="radio-label"><input type="radio" name="visitors_frequency" value="never" checked={formData.visitors_frequency === 'never'} onChange={handleInputChange} /><span>Never/NA</span></label>
            <label className="radio-label"><input type="radio" name="visitors_frequency" value="few_months" checked={formData.visitors_frequency === 'few_months'} onChange={handleInputChange} /><span>Every few months maybe</span></label>
            <label className="radio-label"><input type="radio" name="visitors_frequency" value="monthly" checked={formData.visitors_frequency === 'monthly'} onChange={handleInputChange} /><span>Every month probably</span></label>
            <label className="radio-label"><input type="radio" name="visitors_frequency" value="weekly" checked={formData.visitors_frequency === 'weekly'} onChange={handleInputChange} /><span>Every week probably</span></label>
            <label className="radio-label"><input type="radio" name="visitors_frequency" value="often" checked={formData.visitors_frequency === 'often'} onChange={handleInputChange} /><span>Often</span></label>
          </div>
        </div>
        <div className="form-group">
          <label className="input-label">D5. Overnight guests? (in current/expected circumstances)</label>
          <div className="radio-group vertical">
            <label className="radio-label"><input type="radio" name="overnight_guests" value="never" checked={formData.overnight_guests === 'never'} onChange={handleInputChange} /><span>Never</span></label>
            <label className="radio-label"><input type="radio" name="overnight_guests" value="rarely" checked={formData.overnight_guests === 'rarely'} onChange={handleInputChange} /><span>Rarely</span></label>
            <label className="radio-label"><input type="radio" name="overnight_guests" value="monthly" checked={formData.overnight_guests === 'monthly'} onChange={handleInputChange} /><span>Monthly</span></label>
            <label className="radio-label"><input type="radio" name="overnight_guests" value="weekly" checked={formData.overnight_guests === 'weekly'} onChange={handleInputChange} /><span>Weekly</span></label>
            <label className="radio-label"><input type="radio" name="overnight_guests" value="more_often" checked={formData.overnight_guests === 'more_often'} onChange={handleInputChange} /><span>More often</span></label>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">D6. Religious &amp; Cultural Requirements</label>
        <textarea name="religious_cultural_requirements" value={formData.religious_cultural_requirements} onChange={handleInputChange} className="input-field" rows="3" placeholder="Any religious or cultural practices/requirements we should know about (e.g., quiet time for prayer, cooking style, dietary restrictions, specific holidays)" />
      </div>
    </div>
  );
}

// Step 5: Health & Accessibility — Section H
export function renderHealthAccessibility(formData, handleInputChange, errors) {
  const medicalOptions = ['Diabetes', 'Arthritis', 'Asthma', 'Heart Condition', 'High Blood Pressure', 'Dementia', 'Other'];
  const accessibilityOptions = ['Ground Floor Required', 'Grab Rails Required', 'Lift Access Required'];

  return (
    <div className="form-step" data-testid="step-5h">
      <h2>Section H — Health &amp; Accessibility</h2>
      <p className="step-description">This helps us find housing that meets your physical needs. All information is kept strictly confidential.</p>

      <div className="form-group">
        <label className="input-label">H1. Medical Conditions (Select all that apply)</label>
        <p className="field-hint">Select all that apply</p>
        <div className="checkbox-grid two-col">
          {medicalOptions.map(opt => (
            <label key={opt} className="checkbox-label">
              <input type="checkbox" name="medical_conditions[]" value={opt} checked={formData.medical_conditions?.includes(opt)} onChange={handleInputChange} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">H2. Disability/s?</label>
        <p className="field-hint">Select your mobility/disability status</p>
        <div className="radio-group vertical">
          <label className="radio-label"><input type="radio" name="mobility_status" value="fully_mobile" checked={formData.mobility_status === 'fully_mobile'} onChange={handleInputChange} /><span>Fully mobile for normal activities</span></label>
          <label className="radio-label"><input type="radio" name="mobility_status" value="some_difficulty" checked={formData.mobility_status === 'some_difficulty'} onChange={handleInputChange} /><span>Walk with some difficulty</span></label>
          <label className="radio-label"><input type="radio" name="mobility_status" value="walking_frame" checked={formData.mobility_status === 'walking_frame'} onChange={handleInputChange} /><span>Walking frame</span></label>
          <label className="radio-label"><input type="radio" name="mobility_status" value="disability_scooter" checked={formData.mobility_status === 'disability_scooter'} onChange={handleInputChange} /><span>Disability scooter</span></label>
          <label className="radio-label"><input type="radio" name="mobility_status" value="other" checked={formData.mobility_status === 'other'} onChange={handleInputChange} /><span>Other</span></label>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">H3. Accessibility Requirements (Select all that apply)</label>
        <div className="checkbox-grid two-col">
          {accessibilityOptions.map(opt => (
            <label key={opt} className="checkbox-label">
              <input type="checkbox" name="accessibility_requirements[]" value={opt} checked={formData.accessibility_requirements?.includes(opt)} onChange={handleInputChange} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">H4. Other Accessibility Needs</label>
        <textarea name="other_accessibility_needs" value={formData.other_accessibility_needs} onChange={handleInputChange} className="input-field" rows="3" placeholder="Any other accessibility requirements not listed above..." />
      </div>
    </div>
  );
}


// Step 6: Safety & References — Section E
export function renderSafety(formData, handleInputChange, errors) {
  return (
    <div className="form-step" data-testid="step-5">
      <h2>Section E — Safety &amp; References</h2>
      <p className="step-description">We prioritize the safety of our community.</p>

      <div className="form-group">
        <label className="input-label">E1. Police Check Status</label>
        <select name="police_check_status" value={formData.police_check_status} onChange={handleInputChange} className="input-field">
          <option value="">Select...</option>
          <option value="have_current">I have a current police check</option>
          <option value="can_obtain">I can obtain one</option>
          <option value="need_help">I need help obtaining one</option>
        </select>
      </div>

      <div className="form-group">
        <label className="input-label">E2. Can you provide references?</label>
        <div className="radio-group">
          <label className="radio-label">
            <input type="radio" name="can_provide_references" value="true" checked={formData.can_provide_references === true} onChange={(e) => handleInputChange({ target: { name: 'can_provide_references', value: true }})} />
            <span>Yes</span>
          </label>
          <label className="radio-label">
            <input type="radio" name="can_provide_references" value="false" checked={formData.can_provide_references === false} onChange={(e) => handleInputChange({ target: { name: 'can_provide_references', value: false }})} />
            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  );
}

// Step 6: Your Preferences — Section F
export function renderPreferences(formData, handleInputChange, errors) {
  const ENJOY_OPTIONS = ['Community', 'Garden', 'Cooking', 'Shared Meals', 'Music', 'Games', 'Entertainment'];
  const HATE_OPTIONS  = ['Uncleanliness', 'Untidiness', 'Foul language', 'Unkindness', 'Selfishness'];
  const DB_OPTIONS    = [
    'Heavy drinking', 'Aggressive behavior', 'Untidy/messy habits',
    'Overnight guests', 'Loud noise late at night', 'Drug use', 'Poor hygiene',
    'Certain types of pets', 'Unpredictable schedule'
  ];

  return (
    <div className="form-step" data-testid="step-6">
      <h2>Section F — Your Preferences</h2>
      <p className="step-description">Help us find compatible housemates for you.</p>

      <div className="form-row">
        <div className="form-group">
          <label className="input-label">F1. Age Range Preference</label>
          <select name="age_range_preference" value={formData.age_range_preference} onChange={handleInputChange} className="input-field">
            <option value="">No preference</option>
            <option value="50s">50s</option>
            <option value="60s">60s</option>
            <option value="70s">70s</option>
            <option value="80s+">80s+</option>
          </select>
        </div>
        <div className="form-group">
          <label className="input-label">F2. Household Size Preference</label>
          <select name="household_size_preference" value={formData.household_size_preference} onChange={handleInputChange} className="input-field">
            <option value="">No preference</option>
            <option value="2">2 people</option>
            <option value="3">3 people</option>
            <option value="4">4 people</option>
            <option value="5+">5+ people</option>
          </select>
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">F4. Things I would enjoy in our Shared Community</label>
        <div className="checkbox-grid two-col">
          {ENJOY_OPTIONS.map(opt => (
            <label key={opt} className="checkbox-label">
              <input type="checkbox" name="enjoy_checkboxes[]" value={opt} checked={formData.enjoy_checkboxes?.includes(opt)} onChange={handleInputChange} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
        <input type="text" name="other_enjoy" value={formData.other_enjoy} onChange={handleInputChange} className="input-field" style={{marginTop:'10px'}} placeholder="Additional things you would enjoy..."/>
      </div>

      <div className="form-group">
        <label className="input-label">F5. Things I would NOT enjoy in our Shared Community</label>
        <div className="checkbox-grid two-col">
          {HATE_OPTIONS.map(opt => (
            <label key={opt} className="checkbox-label">
              <input type="checkbox" name="hate_checkboxes[]" value={opt} checked={formData.hate_checkboxes?.includes(opt)} onChange={handleInputChange} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
        <input type="text" name="other_hate" value={formData.other_hate} onChange={handleInputChange} className="input-field" style={{marginTop:'10px'}} placeholder="Additional things you would not enjoy..."/>
      </div>

      <div className="form-group">
        <label className="input-label">F6. Deal Makers (What would make this ideal for you?)</label>
        <textarea name="deal_makers" value={formData.deal_makers} onChange={handleInputChange} className="input-field" rows="3" placeholder="e.g., Shared garden space, quiet neighborhood, close to shops..."/>
      </div>

      <div className="form-group">
        <label className="input-label">F7. Non-Negotiable Conditions (What do you absolutely need?)</label>
        <textarea name="non_negotiable_conditions" value={formData.non_negotiable_conditions} onChange={handleInputChange} className="input-field" rows="3" placeholder="e.g., Must have own bathroom, parking space, internet access..."/>
      </div>

      <div className="form-group">
        <label className="input-label">F8. Dealbreaker Behaviours or Situations in our Shared Community</label>
        <p className="field-hint">Are there any behaviours or situations that would make shared living impossible for you?</p>
        <div className="checkbox-grid two-col">
          {DB_OPTIONS.map(opt => (
            <label key={opt} className="checkbox-label">
              <input type="checkbox" name="dealbreakers[]" value={opt} checked={formData.dealbreakers?.includes(opt)} onChange={handleInputChange} data-testid={`dealbreaker-${opt.toLowerCase().replace(/\s/g,'-')}`} />
              <span>{opt}</span>
            </label>
          ))}
        </div>
        <textarea name="other_dealbreakers" value={formData.other_dealbreakers} onChange={handleInputChange} className="input-field" rows="3" style={{marginTop:'10px'}} placeholder="Any other specific concerns (e.g., Foul language, People from other countries/cultures)..." data-testid="deal-breakers-input"/>
      </div>
    </div>
  );
}

// Step 8: Household Compatibility Questions — Section I
export function renderHouseholdCompatibility(formData, handleInputChange, errors) {
  const questions = [
    { key: 'hc_q1', label: 'I1. Describe the kind of household atmosphere you\'re hoping to find. What would a typical good home community look and feel like for you?', placeholder: 'Describe your ideal household atmosphere...' },
    { key: 'hc_q2', label: 'I2. As part of the HSS community, you would be moving into a new home in a new neighbourhood. With that in mind, describe a current or previous neighbourhood (or community) you lived in that you really enjoyed. What made it enjoyable for you? Did it change over time?', placeholder: 'Tell us about a community you enjoyed...' },
    { key: 'hc_q3', label: 'I3. Complete this: "When I imagine living with people I\'ve never met before, my immediate concerns are..."', placeholder: 'My immediate concerns are...' },
    { key: 'hc_q4', label: 'I4. Australia has changed a lot over the past 30 years. What changes do you feel have been most positive and most negative?', placeholder: 'Most positive changes... Most negative changes...' },
    { key: 'hc_q5', label: 'I5. Where do you get most of your daily news? What news source do you trust?', placeholder: 'I mostly get my news from...' },
    { key: 'hc_q6', label: 'I6. Complete this: "Something I believe in fairly strongly that possibly many people around me might disagree with, is..."', placeholder: 'Something I believe in fairly strongly is...' },
    { key: 'hc_q7', label: 'I7. What is something, some issue, that you have recently thought more about and changed your view on?', placeholder: 'I recently changed my view on...' },
    { key: 'hc_q8', label: 'I8. What are the issues that worry you the most now? Not personally, but about Australia, society and the world?', placeholder: 'The issues that worry me most are...' },
    { key: 'hc_q9', label: 'I9. Complete this: "The thing I find most difficult about how the world is changing is..."', placeholder: 'The thing I find most difficult is...' },
  ];

  return (
    <div className="form-step" data-testid="step-8-compat">
      <h2>Section I — Household Compatibility Questions</h2>
      <p className="step-description">These questions help us match you with compatible housemates. There are no right or wrong answers — be honest and thoughtful. Your responses are confidential and only used for matching.</p>
      {questions.map(({ key, label, placeholder }) => (
        <div className="form-group" key={key}>
          <label className="input-label">{label}</label>
          <textarea
            name={key}
            value={formData[key] || ''}
            onChange={handleInputChange}
            className="input-field"
            rows={4}
            placeholder={placeholder}
            data-testid={`compat-${key}`}
          />
        </div>
      ))}
    </div>
  );
}


// Step 9: Useful Items — Section G
export function renderUsefulItems(formData, handleInputChange, errors) {
  const itemOptions = [
    'Car', 'Bicycle', 'Motor bike', 'Microwave', 'Oven', 'Fridge', 'Freezer', 'TV',
    'Music equipment', 'Washing Machine', 'Dryer', 'Mower', 'Whipper snipper',
    'Garden tools', 'Hand tools', 'Power tools', 'Lounge furniture', 'Outdoor furniture'
  ];

  return (
    <div className="form-step" data-testid="step-7">
      <h2>Section G — Useful Items You Could Bring</h2>
      <p className="step-description">What items could you contribute to the shared household?</p>

      <div className="form-group">
        <label className="input-label">G1. Items you could bring</label>
        <div className="checkbox-grid two-col">
          {itemOptions.map(item => (
            <label key={item} className="checkbox-label">
              <input type="checkbox" name="useful_items[]" value={item} checked={formData.useful_items?.includes(item)} onChange={handleInputChange} />
              <span>{item}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="input-label">G2. Other Items</label>
        <input type="text" name="other_items" value={formData.other_items} onChange={handleInputChange} className="input-field" placeholder="List any other useful items"/>
      </div>

      <div className="form-group">
        <label className="input-label">G3. Are you interested in working for HSS as a Member Support role?</label>
        <p className="step-description" style={{ marginTop: '-4px', marginBottom: '10px' }}>
          1 × 6 hr day per week · Award rates · No Pension impact · On-site only (this is not remote work) · Phone & email support only, no face-to-face
        </p>
        <div className="radio-group">
          <label className="radio-label">
            <input type="radio" name="interested_member_support_role" value="yes" checked={formData.interested_member_support_role === 'yes'} onChange={handleInputChange} data-testid="support-role-yes" />
            <span>Yes, I'm interested</span>
          </label>
          <label className="radio-label">
            <input type="radio" name="interested_member_support_role" value="maybe" checked={formData.interested_member_support_role === 'maybe'} onChange={handleInputChange} data-testid="support-role-maybe" />
            <span>Maybe — tell me more</span>
          </label>
          <label className="radio-label">
            <input type="radio" name="interested_member_support_role" value="no" checked={formData.interested_member_support_role === 'no'} onChange={handleInputChange} data-testid="support-role-no" />
            <span>No, not interested</span>
          </label>
        </div>
      </div>
    </div>
  );
}

const housingTypeLabels = {
  single_female: 'Single Female → Female Community (4-5 bedroom)',
  single_male: 'Single Male → Male Community (4-5 bedroom)',
  couples: 'Couples → Couples (mixed gender) Community (3-4 bedroom)'
};

export function renderReview(formData) {
  const isCouple = formData.shared_housing_type === 'couples';
  // Membership fee shown is provisional — Gold Envoy assigned if among first 100 at time of submission
  const provisionalFee = isCouple ? '$290' : '$190';
  const provisionalType = isCouple ? 'Couples Member' : 'Single Member';

  return (
    <div className="form-step" data-testid="step-8">
      <h2>Review Your Application</h2>
      <p className="step-description">Please review your information before submitting.</p>

      {/* Gold Envoy launch badge — prominent */}
      <div style={{ background: 'linear-gradient(135deg, #b45309 0%, #d97706 100%)', borderRadius: '12px', padding: '20px 24px', marginBottom: '20px', textAlign: 'center', boxShadow: '0 4px 16px rgba(180,83,9,0.3)' }} data-testid="gold-envoy-badge">
        <div style={{ fontSize: '28px', fontWeight: '900', color: 'white', letterSpacing: '0.04em', marginBottom: '4px' }}>
          ★ GOLD ENVOY LAUNCH OFFER
        </div>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#fef3c7', marginBottom: '4px' }}>
          You qualify for the <strong style={{ color: 'white' }}>$20 Lifetime Membership</strong>
        </div>
        <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)' }}>
          First 100 applicants only — confirmed on submission. Normal price: {isCouple ? '$290' : '$190'}/lifetime.
        </div>
      </div>

      {/* Membership type & fee */}
      <div style={{ background: '#fffbeb', border: '2px solid #fbbf24', borderRadius: '10px', padding: '14px 18px', marginBottom: '20px' }}>
        <div style={{ fontWeight: '800', fontSize: '15px', color: '#1a2332', marginBottom: '4px' }}>Your Membership Type</div>
        <div style={{ fontSize: '14px', color: '#92400e' }}>
          <strong>{provisionalType}</strong> — Gold Envoy launch fee: <strong>$20 / 6 months</strong> (payment only after approval)
        </div>
      </div>
      
      <div className="review-section">
        <h3>Personal Details</h3>
        <p><strong>Shared Housing Type:</strong> {housingTypeLabels[formData.shared_housing_type] || formData.shared_housing_type?.replace('_', ' ')}</p>
        <p><strong>Name:</strong> {formData.first_name} {formData.last_name}</p>
        <p><strong>Phone:</strong> {formData.phone}</p>
        <p><strong>Address:</strong> {formData.city}, {formData.state} {formData.postcode}</p>
      </div>

      <div className="review-section">
        <h3>Financial Information</h3>
        <p><strong>Income Sources:</strong> {formData.income_sources?.join(', ') || 'Not specified'}</p>
      </div>

      <div className="review-section">
        <h3>Lifestyle</h3>
        <p><strong>Smoke-free:</strong> All HSS properties are smoke-free.</p>
        <p><strong>Pets:</strong> {formData.has_pets ? 'Yes' : 'No'}{formData.has_pets && formData.pet_details ? ` - ${formData.pet_details}` : ''}</p>
        <p><strong>Daily Routine:</strong> {Array.isArray(formData.daily_routine) ? formData.daily_routine.map(r => r.replace('_', ' ')).join(', ') : (formData.daily_routine || '').replace('_', ' ')}</p>
        <h3>Household</h3>
        {formData.hobbies?.length > 0 && <p><strong>Hobbies:</strong> {formData.hobbies.join(', ')}</p>}
      </div>

      <div className="declaration">
        <p><strong>Declaration:</strong> I declare that the information provided is true and accurate to the best of my knowledge.</p>
      </div>
    </div>
  );
}
